/**
 * ミッション共通の実音源（public/sounds/ の mp3）効果音の定義。
 *
 * これまでアセット取得不可で合成音（playSynth の合成ジングル）で近似していた
 * ゴール音・失敗音・大砲音などを、プロダクトが用意した実際の効果音へ差し替える
 * ための一元定義。複数ミッションで同じ音を使う（成功音・失敗音など）ため、
 * URL と音量の単一の出どころをここに集約する（DRY）。
 *
 * 再生は audio.ts の playSample が担う（プレイ停止で鳴り残らないよう
 * ctx.signal を渡す）:
 *   playSample(GOAL_SUCCESS_SFX.url, GOAL_SUCCESS_SFX.volume, ctx.signal)
 */

/** 実音源 1 つの定義（URL と音量）。 */
export interface SampleSfx {
  readonly url: string
  readonly volume: number
}

/** ゴール・成功系の実音源（10_Goal）。各ミッションの成功・クリア演出で使う。 */
export const GOAL_SUCCESS_SFX: SampleSfx = {
  url: '/sounds/sfx-goal-success.mp3',
  volume: 0.4,
}

/** 失敗・ゲームオーバー系の実音源（11）。落下・被発見・失敗判定などで使う。 */
export const FAIL_GAMEOVER_SFX: SampleSfx = {
  url: '/sounds/sfx-fail-gameover.mp3',
  volume: 0.4,
}

/** 大砲の発射音（12_ビーム音）。RJF05 の砲撃で使う。 */
export const CANNON_BEAM_SFX: SampleSfx = {
  url: '/sounds/sfx-cannon-beam.mp3',
  volume: 0.3,
}

/** ゲーム開始の合図音（13_デンッ！）。RJF05 のスタート表示で使う。 */
export const GAME_START_SFX: SampleSfx = {
  url: '/sounds/sfx-game-start.mp3',
  volume: 0.4,
}

/** マト命中音（14_発見！）。RJF05 の砲弾がマトに当たった時に使う。 */
export const TARGET_HIT_SFX: SampleSfx = {
  url: '/sounds/sfx-target-hit.mp3',
  volume: 0.4,
}

/** スタートの合図音（15_ジャンッ）。レース系のゲームスタートで使う。 */
export const JUMP_SFX: SampleSfx = {
  url: '/sounds/sfx-jump.mp3',
  volume: 0.4,
}

/** 審判のホイッスル音（16）。落下・ゲーム終了などの合図で使う。 */
export const WHISTLE_SFX: SampleSfx = {
  url: '/sounds/sfx-whistle.mp3',
  volume: 0.4,
}

/**
 * ブロック生成音「コンッ」（17）。クローン生成のたびに鳴らす。
 * 数秒ごとに連続発火するため、他の単発 SFX より控えめの音量にする。
 */
export const BLOCK_SPAWN_SFX: SampleSfx = {
  url: '/sounds/sfx-block-spawn.mp3',
  volume: 0.3,
}
